var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.298765 10.307C-0.0884947 10.6943 -0.0884947 11.3222 0.298765 11.7095C0.686146 12.0968 1.31395 12.0968 1.70133 11.7095L6.70956 6.70123C7.09682 6.31397 7.09682 5.68605 6.70956 5.2988L1.70133 0.290444C1.31395 -0.0968156 0.686147 -0.0968157 0.298766 0.290444C-0.0884938 0.677704 -0.0884938 1.30562 0.298766 1.69288L4.60584 5.99995L0.298765 10.307Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.010ed56c4250c749a2e84505cc8bdda3.svg";
export { ForwardRef as ReactComponent };